const normalizeTag = tag => typeof tag === 'string'
  ? tag.trim().toLowerCase().replace(/\s+/g, ' ').replace(/\s*-\s*/g, '-') : '';
const leaveTags = new Set(['toil', 'sick leave-paid', 'sick leave-unpaid', 'annual leave']);

export const isSickLeaveTag = tag => ['sick leave-paid', 'sick leave-unpaid'].includes(normalizeTag(tag));
export const isLeaveShift = shift => Array.isArray(shift?.tags) && shift.tags.some(tag => leaveTags.has(normalizeTag(tag)));
